// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VideoIconStatus {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 1;
}
.VideoIconStatus__icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.VideoIconStatus__icon-wrapper:hover {
  background-color: #f6f0ff;
  background-color: var(--color_primary_100, #f6f0ff);
}
.VideoIconStatus__icon-wrapper--clickable {
  cursor: pointer;
}
.VideoIconStatus__icon-wrapper--success {
  color: #6b7280;
  color: var(--color_neutral_500, #6b7280);
}
.VideoIconStatus__icon-wrapper--success:hover {
  color: var(--color_neutral_800);
}
.VideoIconStatus__icon-wrapper--success-clickable {
  position: relative;
}
.VideoIconStatus__icon-wrapper--success-clickable .VideoIconStatus__icon-hover {
  display: none;
}
.VideoIconStatus__icon-wrapper--success-clickable:hover .VideoIconStatus__icon-default {
  display: none;
}
.VideoIconStatus__icon-wrapper--success-clickable:hover .VideoIconStatus__icon-hover {
  display: inline;
}`, "",{"version":3,"sources":["webpack://./src/modules/posts/video-icon-status/video-icon-status.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uDACE;AAAN;AAGI;EACE,yBAAA;EAAA,mDAAA;AADN;AAII;EACE,eAAA;AAFN;AAKI;EACE,cAAA;EAAA,wCAAA;AAHN;AAKM;EACE,+BAAA;AAHR;AAOI;EACE,kBAAA;AALN;AAMM;EACE,aAAA;AAJR;AAMM;EACE,aAAA;AAJR;AAMM;EACE,eAAA;AAJR","sourcesContent":[".VideoIconStatus {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  line-height: 1;\n\n  &__icon-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    transition:\n      background-color 0.2s ease,\n      color 0.2s ease;\n\n    &:hover {\n      background-color: var(--color_primary_100, #f6f0ff);\n    }\n\n    &--clickable {\n      cursor: pointer;\n    }\n\n    &--success {\n      color: var(--color_neutral_500, #6b7280);\n\n      &:hover {\n        color: var(--color_neutral_800);\n      }\n    }\n\n    &--success-clickable {\n      position: relative;\n      .VideoIconStatus__icon-hover {\n        display: none;\n      }\n      &:hover .VideoIconStatus__icon-default {\n        display: none;\n      }\n      &:hover .VideoIconStatus__icon-hover {\n        display: inline;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
